// @flow

import _ from 'lodash';
import React, { Component, Children, type Node } from 'react';
import CookieBanner from 'client/components/banner/CookieBanner';
import HtmlHead from 'client/components/htmlHead';
import NpnFooter from 'client/components/npnFooter';
import { fetchCart } from 'client/actions/cart';
import { fetchContentful } from 'client/actions/contentful';
import { fetchCrossSellSource } from 'client/actions/ifpCrossSell';
import { fetchMembers } from 'client/actions/members';
import { fetchOrCreateAppByType } from 'client/actions/ifpApps';
import { fetchUser } from 'client/actions/user';
import 'client/styles/common.scss';

type Props = {
  children: Node,
  location: {
    basename: '/vision',
    pathname: string,
  },
};

const CONTENTFUL_ENTRY_ID = '6BMlsm5JDRLEwJSPgGWSqa';

/**
 * Vision app creates ifp_app every time an ifp_app vision app is submitted.
 * If multiple apps exist, prod ops sends the latest to Renaissance.
 */
class App extends Component<Props> {
  static fetchData({ dispatch, getState }: { dispatch: Function, getState: Function }) {
    return Promise.all([
      dispatch(fetchUser()),
      dispatch(fetchMembers()),
      dispatch(fetchOrCreateAppByType('vision', { is_complete: false })),
    ])
      .then((response) => {
        const locale = _.get(response, '[0].locale', 'en-US');
        return dispatch(fetchContentful(CONTENTFUL_ENTRY_ID, locale));
      })
      .then(() => {
        const state = getState();
        const visionApp = _.find(state.ifpApps, { type: 'vision' });
        const isLoggedIn = _.get(state, 'user.isLoggedIn', false);
        const appId = _.get(visionApp, 'app_id', null);

        if (isLoggedIn && appId) {
          return dispatch(fetchCrossSellSource(appId));
        }

        return null;
      })
      .then((crossSell) => {
        if (crossSell) {
          return dispatch(fetchCart());
        }

        return null;
      });
  }

  render() {
    return (
      <div>
        <HtmlHead
          title="Stride Health - Vision Insurance"
          description="Vision insurance for less than $10/month" />
        {Children.only(this.props.children)}
        <CookieBanner />
        <NpnFooter showRenaissanceDisclaimer showPhone={false} />
      </div>
    );
  }
}

export default App;
